import React from 'react';
import About from '../components/About/About';
import Contact from '../components/Contact/Contact';
import Hero from '../components/Hero/Hero';
import ProjectSection from '../components/Projects/ProjectSection';
import Skills from '../components/Skills/SkillsCard';

export default function Home() {
  return (
    <div>
      <Hero />
      <About />
      <Skills />
      <ProjectSection />
      <Contact />
    </div>
  );
}
